import { BasePortfolio } from './base-portfolio';
import { PerformanceReturn } from './performance-return';
import { RiskAnalytics } from './risk-analytics';
import { Security } from './security';

export class Portfolio extends BasePortfolio {
	private _owner: string;
	private _baseModel: number;
	private _expenseRatio: number;
	private _portfolioId: number;
	private _performanceReturn: PerformanceReturn;
	private _riskScenarios: Map<string, number>;
	private _riskAnalytics: RiskAnalytics;
	private _yieldValue: number;
	private _baseEngagementPortfolio: string;
	private _perms: string[] = [];

	constructor() {
		super();
	}

	public get securities(): Array<Security> {
		return this.children as Array<Security>;
	}

	public set securities(value: Array<Security>) {
		this.children = value;
	}

	public get baseModel(): number {
		return this._baseModel;
	}

	public set baseModel(value: number) {
		this._baseModel = value;
	}

	public get expenseRatio(): number {
		return this._expenseRatio;
	}

	public set expenseRatio(value: number) {
		this._expenseRatio = value;
	}

	public get portfolioId(): number {
		return this._portfolioId;
	}

	public set portfolioId(value: number) {
		this._portfolioId = value;
	}

	public get performanceReturn(): PerformanceReturn {
		return this._performanceReturn;
	}

	public set performanceReturn(value: PerformanceReturn) {
		this._performanceReturn = value;
	}

	public get riskScenarios(): Map<string, number> {
		return this._riskScenarios;
	}

	public set riskScenarios(value: Map<string, number>) {
		this._riskScenarios = value;
	}

	public get riskAnalytics(): RiskAnalytics {
		return this._riskAnalytics;
	}

	public set riskAnalytics(value: RiskAnalytics) {
		this._riskAnalytics = value;
	}

	public get yieldValue(): number {
		return this._yieldValue;
	}

	public set yieldValue(value: number) {
		this._yieldValue = value;
	}

	public get owner(): string {
		return this._owner;
	}

	public set owner(owner: string) {
		this._owner = owner;
	}

	public get perms(): string[] {
		return this._perms;
	}

	public set perms(perms: string[]) {
		this._perms = perms;
	}

	public set baseEngagementPortfolio(baseEngagementPortfolio: string) {
		this._baseEngagementPortfolio = baseEngagementPortfolio;
	}

	public get baseEngagementPortfolio(): string {
		return this._baseEngagementPortfolio;
	}
}
